module.exports = __webpack_public_path__ + "static/media/ednaBurial081.c4a0f207.png";